"use strict";

var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}
var API_KEY_TEMPLATE_PARAMETER = '{apiKey}';
/**  Token Contract  **/

/*
    Tokens recieved by this adapter from endpoints specified above must return in the following JSON format:
    {
        ValidTo: 'some date in UTC',
        TokenType: 'Bearer',
        IdToken: 'some long token'
    }
*/

var TokenRetrievalAdapter = /*#__PURE__*/
function () {
  function TokenRetrievalAdapter(_ref) {
    var apiKey = _ref.apiKey,
      batchUrlTemplate = _ref.batchUrlTemplate;
    _classCallCheck(this, TokenRetrievalAdapter);
    this.apiKey = apiKey;
    this.batchUrlTemplate = batchUrlTemplate;
  }
  _createClass(TokenRetrievalAdapter, [{
    key: "getBatchTokensByApiKey",
    value: function getBatchTokensByApiKey() {
      //resolve empty value if there is no api key - so we know to use the fallback method
      if (!this.apiKey) {
        return Promise.resolve();
      }
      var url = this.batchUrlTemplate.replace(API_KEY_TEMPLATE_PARAMETER, this.apiKey);
      return _axios["default"].get(url);
    }
  }]);
  return TokenRetrievalAdapter;
}();
module.exports = TokenRetrievalAdapter;